import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { LocationContext } from 'common/containers/RouterContainer';
import LazyLoadedImage from 'common/LazyLoadedImage';
import Link from 'common/Link';
import UppercaseHeader from 'common/UppercaseHeader';
import devURL from 'common/util/devURL';
import withContexts from 'common/util/withContexts';

import { Discord, Instagram, LinkedIn, X, YouTube } from './icons';

import CannyIcon from 'img/canny-icon.svg';

import 'css/components/www/_LandingFooter.scss';

class LandingFooter extends Component {
  static propTypes = {
    location: PropTypes.object,
  };

  renderIcon(Icon, className, url) {
    return (
      <a className={'socialIcon ' + className} rel="noopener noreferrer" target="_blank" href={url}>
        {Icon}
      </a>
    );
  }

  render() {
    const {
      location: { pathname },
    } = this.props;
    const whiteBackground = pathname !== '/' && pathname !== '/pricing';
    const className = 'landingFooter' + (whiteBackground ? ' white' : '');
    const currentYear = new Date().getFullYear();
    return (
      <footer className={className}>
        <div className="footerContainer">
          <div className="footerInfo">
            <Link to="/">
              <LazyLoadedImage alt="Canny logo" className="cannyIcon" src={CannyIcon} />
            </Link>
            <div className="footerText">Build better products with customer&nbsp;feedback</div>
            <div className="socialIcons">
              {this.renderIcon(LinkedIn, 'linkedin', 'https://www.linkedin.com/company/18048936/')}
              {this.renderIcon(Discord, 'discord', 'https://discord.gg/R89Wd8g3aY')}
              {this.renderIcon(YouTube, 'youtube', 'https://www.youtube.com/@cannyio')}
              {this.renderIcon(X, 'x', 'https://x.com/cannyhq')}
              {this.renderIcon(Instagram, 'instagram', 'https://www.instagram.com/canny.io/')}
            </div>
            <div className="text">
              <div>&copy; Canny {currentYear}</div>
              <div>
                <a href="/privacy" target="_blank">
                  Privacy
                </a>
                {' · '}
                <a href="/terms" target="_blank">
                  Terms
                </a>
                {' · '}
                <Link to="/security">Security</Link>
              </div>
            </div>
          </div>
          <div className="sections">
            <div className="section">
              <Link to="/compare">
                <UppercaseHeader>Compare</UppercaseHeader>
              </Link>
              <Link to="/compare/uservoice">UserVoice</Link>
              <Link to="/compare/aha">Aha Ideas</Link>
              <Link to="/compare/trello">Trello</Link>
            </div>
            <div className="section">
              <UppercaseHeader>Connect</UppercaseHeader>
              <Link to="/request-demo">Book a demo</Link>
              <Link to="/about">About Us</Link>
              <a href="https://canny.io/blog/" rel="noopener" target="_blank">
                Blog
              </a>
              <a href={devURL('https://productchats.canny.io')} rel="noopener" target="_blank">
                Product Chats Podcast
              </a>
              <a href="https://careers.canny.io" rel="noopener" target="_blank">
                Careers
              </a>
              <a href="https://twitter.com/cannyHQ" rel="noopener" target="_blank">
                Twitter
              </a>
              <a href={devURL('https://feedback.canny.io')} rel="noopener" target="_blank">
                Feedback
              </a>
            </div>
            <div className="section">
              <UppercaseHeader>Product</UppercaseHeader>
              <Link to="/features">Features</Link>
              <Link to="/pricing">Pricing</Link>
              <Link to="/use-cases">Use Cases</Link>
              <Link to="/integrations">Integrations</Link>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default withContexts({ location: LocationContext })(LandingFooter);
